
// Language switcher removed - Swedish only
export default function LanguageSwitcher() {
  return null;
}
